// External
import { gql } from "@apollo/client";

export const getRemarkLogsQuery = gql`
  query getRemarkLogs($input: RemarkLogsInput!) {
    documentation {
      internalToolsData {
        progressReport {
          remarkLogs(input: $input) {
            courseName
            gradeName
            studentName
            teacherName
            subjectName
            commentLabel
            oldComment
            newComment
            updatedAt
          }
        }
      }
    }
  }
`;
